import { render, staticRenderFns } from "./ReceiptInput.vue?vue&type=template&id=712f8915&scoped=true&"
import script from "./ReceiptInput.vue?vue&type=script&lang=js&"
export * from "./ReceiptInput.vue?vue&type=script&lang=js&"
import style0 from "./ReceiptInput.vue?vue&type=style&index=0&id=712f8915&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "712f8915",
  null
  
)

export default component.exports